<script setup>
import { inject, computed, watch } from 'vue';
import Modal from '../Modal.vue';
import Button from '../components/Button.vue';
import Icon from '../Icon.vue';
import { checkout, redirectToStripePortal } from '../payments/paymentActions';
import { capturePosthog } from '../posthog';

const billingIssue = inject('billingIssue')
const cfg = computed(() => {
  switch (billingIssue.value) {
    case 'UPGRADE_REQUIRED': return {
      title: 'You’ve run out of AI credits!',
      text: 'Upgrade your plan to continue creating documents with Spell',
      btnText: 'Upgrade my plan',
      onOK: () => checkout('subscription')
    }
    case 'RENEWAL_REQUIRED': return {
      title: 'Your subscription wasn’t renewed!',
      text: 'Your subscription wasn’t renewed due to a payment issue. Please visit the Subscription Portal to update your payment method and restore access.',
      btnText: 'Manage my subscription',
      onOK: () => redirectToStripePortal()
    }
    case 'NEED_CREDITS': return {
      title: 'You’ve run out of AI credits!',
      text: 'Your credit balance is empty. You can buy more additional credits to continue using the assistant.',
      btnText: 'Buy more credits',
      onOK: () => checkout('credits')
    }
    case 'DOCUMENT_LIMIT': return {
      title: 'You’ve reached your document limit!',
      text: 'You’ve reached the document limit for the free plan. Please upgrade to the Pro plan to continue generating documents.',
      btnText: 'Upgrade my plan',
      onOK: () => checkout('subscription')
    }
    case 'DOCUMENT_EDIT_LIMIT': return {
      title: 'You’ve reached the edit limit!',
      text: 'You’ve reached the edit limit for the free plan. Please upgrade to the Pro plan to continue making document edits.',
      btnText: 'Upgrade my plan',
      onOK: () => checkout('subscription')
    }
    default: return {
      title: 'There’s an issue with your subscription',
      text: 'It looks like there’s a problem with your current plan. Please check your billing details or update your subscription to continue using all features.',
      btnText: 'Manage my subscription',
      onOK: () => redirectToStripePortal()
    }
  }
})

watch(billingIssue, code => {
  if (code) {
    capturePosthog('paywall', {
      code
    })
  }
})

</script>

<template>

  <Modal v-if="billingIssue"
         :title="cfg.title" 
         theme="light"
         :full-size="false" :close-btn="true" @close="billingIssue=null">
    <div class="p-1 flex flex-col items-center h-full space-y-4" style="max-width: 480px;">
      <p>{{ cfg.text }}</p>
      <div class="self-end flex gap-3">
        <Button @action="() => {cfg.onOK(); billingIssue=null}" class="btn-primary">
          <span style="display: flex; align-items: center; gap: 8px">
            {{ cfg.btnText }}
            <Icon name="ri--arrow-right-fill" :size="16"/>
          </span>
        </Button>
      </div>
    </div>
  </Modal>

</template>